module.exports = __webpack_public_path__ + "assets/img/tit2.d8c9f770.png";